import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination } from 'react-bootstrap';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import { toast } from 'react-toastify';

function UsersList() {
    const [users, setUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(10);

    const fetchUsers = async () => {
        try {
            const auth_token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/users?page=${currentPage}&per_page=${perPage}`, {
                headers: { Authorization: `Bearer ${auth_token}` }
            });
            setUsers(response.data.data);
            setTotalPages(Math.ceil(response.data.total / response.data.per_page));
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to load users');
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [currentPage]);

    const deleteApi = async (id) => {
        if (!window.confirm('Are you sure you want to delete this user?')) return;
        try {
            const auth_token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/users/${id}`, {
                headers: { Authorization: `Bearer ${auth_token}` }
            });
            toast.success('User deleted successfully');
            fetchUsers();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to delete user');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1
                    pagetitle="Users List"
                    righttitle="Add User"
                    link="/accounts/users-add"
                    routebutton={true}
                    permission="users.create"
                />
                <Card className="mb-3">
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>Permissions</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.map((user, index) => (
                                    <tr key={user.id}>
                                        <td>#{(currentPage - 1) * perPage + index + 1}</td>
                                        <td>{user.name}</td>
                                        <td>{user.email}</td>
                                        <td>
                                            <span className="badge bg-primary">
                                                {user.roles.join(', ')}
                                            </span>
                                        </td>
                                        <td>
                                            {user.permissions.length > 0 ? (
                                                user.permissions.map((permission) => (
                                                    <span key={permission} className="badge bg-info me-1">
                                                        {permission}
                                                    </span>
                                                ))
                                            ) : (
                                                <span className="text-muted">—</span>
                                            )}
                                        </td>
                                        <td>
                                            <span className={`badge ${user.is_active ? 'bg-success' : 'bg-warning'}`}>
                                                {user.is_active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <EditButton
                                                    to={`${process.env.PUBLIC_URL}/accounts/users-edit/${user.id}`}
                                                    permission="users.edit"
                                                />
                                                <DeleteButton
                                                    onDelete={() => deleteApi(user.id)}
                                                    permission="users.delete"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First 
                                    onClick={() => handlePageChange(1)} 
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev 
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}
                                />
                                
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={idx + 1 === currentPage}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                
                                <Pagination.Next 
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last 
                                    onClick={() => handlePageChange(totalPages)} 
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default UsersList;
